import config from '../../config/customer.api'
import { appInsights } from '../shared/applicationInsights'
import { Request } from '../shared/base.requests'

const ownersModule = {
  namespaced: true,
  state: {
    makes: [],
    models: [],
    years: [],
    owners: [],
    ownersHistory: []
  },
  mutations: {
    setMakes (state, payload) {
      state.makes = payload
    },
    setHistory (state, payload) {
      state.ownersHistory = payload
    },
    setModels (state, payload) {
      state.models = payload
    },
    setYears (state, payload) {
      state.years = payload
    },
    setOwners (state, payload) {
      state.owners = payload
    }
  },
  actions: {
    loadOwnerMakes: function (context) {
      context.commit('setModels', [])
      context.commit('setYears', [])
      context.commit('setOwners', [])

      return new Promise((resolve, reject) => {
        Request.get(config.getOwnerMakes)
          .then((response) => {
            context.commit('setMakes', response)
            resolve()
          })
          .catch((error) => {
            appInsights.trackException({
              exception: error,
              message: error.message,
              properties: {
                apiUrl: config.getOwnerMakes,
                accessId: localStorage.accessId
              }
            })
            appInsights.flush()

            console.error('setMakes failed', error)
            reject()
          })
      })
    },
    loadOwnerHistory: function (context) {
      return new Promise((resolve, reject) => {
        Request.get(config.loadOwnerHistory)
          .then((response) => {
            context.commit('setHistory', response)
            resolve()
          })
          .catch((error) => {
            appInsights.trackException({
              exception: error,
              message: error.message,
              properties: {
                apiUrl: config.loadOwnerHistory,
                accessId: localStorage.accessId
              }
            })
            appInsights.flush()

            reject()
          })
      })
    },
    loadOwnerModels: function (context, payload) {
      context.commit('setYears', [])
      context.commit('setOwners', [])

      return new Promise((resolve, reject) => {
        let apiUrl = config.getOwnerModels + '/?make=' + payload.make
        Request.get(apiUrl)
          .then((response) => {
            context.commit('setModels', response)
            resolve()
          })
          .catch((error) => {
            appInsights.trackException({
              exception: error,
              message: error.message,
              properties: { apiUrl: apiUrl, accessId: localStorage.accessId }
            })
            appInsights.flush()

            console.error('setCustomer failed', error)
            reject()
          })
      })
    },
    loadOwnerYears: function (context, payload) {
      context.commit('setOwners', [])

      return new Promise((resolve, reject) => {
        let apiUrl =
          config.getOwnerYears +
          '/?make=' +
          payload.make +
          '&model=' +
          payload.model
        Request.get(apiUrl)
          .then((response) => {
            context.commit('setYears', response)
            resolve()
            let apiUrl =
              config.getOwners +
              '/?make=' +
              payload.make +
              '&model=' +
              payload.model +
              '&year=' +
              payload.year
            Request.get(apiUrl)
              .then((response) => {
                console.log(response)
                context.commit('setOwners', response)
                resolve()
              })
              .catch((error) => {
                appInsights.trackException({
                  exception: error,
                  message: error.message,
                  properties: {
                    apiUrl: apiUrl,
                    accessId: localStorage.accessId
                  }
                })
                appInsights.flush()

                console.error('setCustomer failed', error)
                reject()
              })
          })
          .catch((error) => {
            appInsights.trackException({
              exception: error,
              message: error.message,
              properties: { apiUrl: apiUrl, accessId: localStorage.accessId }
            })
            appInsights.flush()

            console.error('setCustomer failed', error)
            reject()
          })
      })
    },
    loadOwner: function (context, payload) {
      return new Promise((resolve, reject) => {
        let apiUrl =
          config.getOwners +
          '/?make=' +
          payload.make +
          '&model=' +
          payload.model +
          '&year=' +
          payload.year
        Request.get(apiUrl)
          .then((response) => {
            console.log(response)
            context.commit('setOwners', response)
            resolve()
          })
          .catch((error) => {
            appInsights.trackException({
              exception: error,
              message: error.message,
              properties: { apiUrl: apiUrl, accessId: localStorage.accessId }
            })
            appInsights.flush()

            console.error('setCustomer failed', error)
            reject()
          })
      })
    },
    addOwner: function (context, payload) {
      return new Promise((resolve, reject) => {
        let apiUrl =
          config.addOwner +
          '/?make=' +
          payload.make +
          '&model=' +
          payload.model +
          '&year=' +
          payload.year +
          '&submodel=' +
          payload.submodel
        Request.get(apiUrl)
          .then(() => {
            resolve()
          })
          .catch((error) => {
            appInsights.trackException({
              exception: error,
              message: error.message,
              properties: { apiUrl: apiUrl, accessId: localStorage.accessId }
            })
            appInsights.flush()

            reject()
          })
      })
    }
  },
  getters: {
    getOwner: (state) => {
      return state.owners
    },
    getMakes: (state) => {
      return state.makes
    },
    getModels: (state) => {
      return state.models
    },
    getYears: (state) => {
      return state.years
    }
  }
}

export default ownersModule



// WEBPACK FOOTER //
// ./scripts/src/store/owner.module.js